function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["alignContent", "alignItems", "areas", "columnGap", "columns", "component", "className", "display", "justifyContent", "justifyItems", "preset", "responsive", "rowGap", "rows", "uiTheme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { styledComponentsResponsiveStyles } from '../../utils/responsive';
import { getPreset } from '../Theme/selectors';
import withTheme from '../Theme/withTheme';
import gridPropsToCss from './props-to-css';
var Grid = function Grid(_ref) {
  var alignContent = _ref.alignContent,
    alignItems = _ref.alignItems,
    areas = _ref.areas,
    columnGap = _ref.columnGap,
    columns = _ref.columns,
    Component = _ref.component,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    display = _ref.display,
    justifyContent = _ref.justifyContent,
    justifyItems = _ref.justifyItems,
    presetName = _ref.preset,
    responsive = _ref.responsive,
    rowGap = _ref.rowGap,
    rows = _ref.rows,
    uiTheme = _ref.uiTheme,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var preset = presetName ? getPreset(uiTheme, 'grid', presetName) : {};
  var _preset$className = preset.className,
    presetClassName = _preset$className === void 0 ? '' : _preset$className;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: "".concat(className, " ").concat(presetClassName)
  }, otherProps));
};
Grid.defaultProps = {
  alignContent: null,
  alignItems: null,
  areas: null,
  className: null,
  columnGap: null,
  columns: null,
  component: 'div',
  display: null,
  justifyContent: null,
  justifyItems: null,
  preset: null,
  responsive: [],
  rowGap: null,
  rows: null,
  uiTheme: null
};
var StyledGrid = styled(Grid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  var presetName = props.preset,
    uiTheme = props.uiTheme;
  var preset = getPreset(uiTheme, 'grid', presetName);
  return gridPropsToCss(_objectSpread(_objectSpread({
    display: 'grid'
  }, preset), props));
}, function (props) {
  var preset = props.preset,
    uiTheme = props.uiTheme;
  var _getPreset = getPreset(uiTheme, 'grid', preset),
    presetResponsive = _getPreset.responsive;
  return styledComponentsResponsiveStyles(uiTheme, presetResponsive, function (breakpointProps) {
    return gridPropsToCss(_objectSpread({
      uiTheme: uiTheme
    }, breakpointProps));
  });
}, function (props) {
  var responsive = props.responsive,
    uiTheme = props.uiTheme;
  return styledComponentsResponsiveStyles(uiTheme, responsive, function (breakpointProps) {
    return gridPropsToCss(_objectSpread({
      uiTheme: uiTheme
    }, breakpointProps));
  });
});
export default withTheme(StyledGrid);